export default "__VITE_ASSET__BYmeikRZ__"